import Cookies from 'js-cookie';

export const sessionCookie = 'authSession';
const profileFields = ['userId', 'userName', 'userEmail', 'loginUser'];
const tokenOptions = { expires: 7, sameSite: 'Lax' };
const tokenName = (session, name) => `${session}:${name}`;
export const newSession = () => Array.from(crypto.getRandomValues(new Uint32Array(4)), n => n.toString(16)).join('-');

export function sessionId() {
  // Existing cookie sessions keep a stable identity until the next login/logout.
  // Refresh writes scoped tokens without changing the legacy identity cookie.
  const session = Cookies.get(sessionCookie) || (Cookies.get('refreshToken') && `legacy:${Cookies.get('refreshToken')}`)
    || (Cookies.get('accessToken') && `legacy:${Cookies.get('accessToken')}`);
  return session && Cookies.get(tokenName(session, 'revoked')) ? `revoked:${session}` : session;
}

function readValue(name, session) {
  if (!session || session.startsWith('revoked:')) return undefined;
  return Cookies.get(tokenName(session, name))
    || (session.startsWith('legacy:') ? Cookies.get(name) : undefined);
}
export const getAccessToken = (session = sessionId()) => readValue('accessToken', session);
export const getRefreshToken = (session = sessionId()) => readValue('refreshToken', session);

export const getAuthValue = (name, session = sessionId()) => readValue(name, session);
export const setAuthValue = (name, value, options = tokenOptions, session = sessionId()) => {
  if (session && !session.startsWith('revoked:') && value !== undefined) {
    Cookies.set(tokenName(session, name), value, options);
  }
};
export const storeProfile = (profile, session) => {
  profileFields.forEach(name => setAuthValue(name, profile[name], tokenOptions, session));
};

export const storeTokens = ({ accessToken, refreshToken }, session) => {
  if (accessToken) Cookies.set(tokenName(session, 'accessToken'), accessToken, tokenOptions);
  if (refreshToken) Cookies.set(tokenName(session, 'refreshToken'), refreshToken, tokenOptions);
};
export const removeTokens = session => {
  ['accessToken', 'refreshToken', ...profileFields].forEach(name => Cookies.remove(tokenName(session, name)));
};

export const revokeSession = session => {
  if (session && !session.startsWith('revoked:')) {
    Cookies.set(tokenName(session, 'revoked'), '1', { expires: 365, sameSite: 'Lax' });
    removeTokens(session);
  }
};

export const retireSession = session => {
  if (!session) return;
  const previous = session.startsWith('revoked:') ? session.slice('revoked:'.length) : session;
  removeTokens(previous);
  Cookies.remove(tokenName(previous, 'revoked'));
};
